import appBackground from '../../jpeg/view/d.jpg';

import './background.styles.scss';

const Background = (top) => {

	return(
        <div className="line-container" style={{
            backgroundImage: `url(${appBackground})`,
        }}>
            <div className='dark-screen'>                    
                <div className="line"></div>
                <div className="line"></div>
                <div className="line"></div>
                <div className="line"></div>
                <div className="line"></div>
                <div className="line"></div>
                <div className="line"></div>
                <div className="line"></div>
                <div className="line"></div>
            </div>
        </div>
    )
}

export default Background;